import React from 'react';
import Showcase from './components/Showcase';

function App() {
  return (
    <div>
      <Showcase />
    </div>
  );
}

export default App;
